import React from 'react'
import { useTranslate } from '../TranslationText'
import NewActionButton from '../ActionButtons/NewActionButton';
import { eformFormButton } from '../../common/cssclasses';

export default function SubmitServiceBtn({ text = "", ...props }) {
    const { translate } = useTranslate();
    return (
        <div className={eformFormButton}>
            <NewActionButton
                classNames="btn-danger"
                text={
                    <>
                        {!!text ?
                            text :
                            <>
                                <i className="fa-solid fa-circle-check"></i>
                                {translate("web.submit", "Submit")}
                            </>
                        }
                    </>
                }
                {...props}
            />
        </div>
    )
}
